'use strict';

angular.module('reception.components.receptionWhatsNext',
    [
        'angular.filter',
        'pascalprecht.translate',
        'shared.services.registerStateService',
        'shared.components.sbIcon',
        'shared.components.sbAvatar',
        'shared.services.blobStoragePhotosService',
        'teams.components.addTeamNotePopup',
        'teams.components.teamNoteEditor',
        'teams.components.teamNoteList',
    ])
    .component('receptionWhatsNext', {
        bindings: {
            groupId: '<',
            isRegGroup: '<'
        },
        templateUrl: '/Scripts/app/reception/components/reception-whatsnext.template.html',
        controller: [
            '$filter', '$window', '$timeout', 'receptionService', 'registerStateService', 'blobStoragePhotosService', 'organisationServiceNg', 'userServiceNg', '$scope',
            function ($filter, $window, $timeout, receptionService, registerStateService, blobStoragePhotosService, organisationServiceNg, userServiceNg, $scope) {

                this.showSearch = false;
                this.showNext = false;
                this.loadingNext = false;
                this.loadingNextDone = false;
                this.isWeekView = true;

                organisationServiceNg.getCurrentOrganisation().subscribe(function (org) {
                    $scope.$applyAsync(function () {
                        $scope.organisation = org;
                    });
                });

                userServiceNg.getCurrentUser().subscribe(function (user) {
                    $scope.$applyAsync(function() {
                        $scope.currentUser = user;
                        $scope.isAdmin = userServiceNg.isAdmin();
                    });
                });

                this.days = [0, 1, 2, 3, 4, 5, 6];

                this.receptionRegisterStateService = registerStateService;

                this.dateOptions = {
                    formatYear: 'yy',
                    startingDay: 1
                };

                this.formats = ['dd-MMMM-yyyy', 'dd.MM.yyyy', 'dd/MM/yyyy', 'shortDate', 'dd-MMM-yyyy', 'dd MMM yyyy'];
                this.format = 'dd MMM yyyy';

                this.openFrom = function () {
                    this.popupFrom.opened = true;
                };

                this.navigate = function (interval) {
                    var days = (this.isWeekView) ? 7 : 1;
                    this.groupsFrom = moment(this.groupsFrom).add(interval * days, 'd');
                    this.refresh();

                }.bind(this);

                this.switchView = function () {
                    this.refresh();
                }.bind(this);

                this.popupFrom = {
                    opened: false
                };

                this.addDays = function (date, days) {
                    var result = new Date(date);
                    result.setDate(result.getDate() + days);
                    return result;
                }

                this.inTimeSlot = function (groupsFrom, eventTime, days) {
                    var groupsFromDate = new Date(groupsFrom);
                    groupsFromDate.setDate(groupsFromDate.getDate() + days);

                    var groupsFromDateMoment = moment(groupsFromDate).startOf('day');
                    var eventTimeDate = moment(eventTime).startOf('day');

                    return groupsFromDateMoment.valueOf() === eventTimeDate.valueOf();
                }

                this.groupsFrom = moment(new Date()).startOf('day');

                this.$onChanges = function (changes) {

                    if ((changes.groupId && changes.groupId.currentValue)) {
                        this.refresh();
                    }
                }.bind(this);

                this.buildSearchFilters = function () {

                    this.searchFilters = {
                        team: "", schoolYear: "", className: ""
                    };


                    this.uniqueClassNames = [];

                    var uniqueClassNameItems = $filter('unique')(this.members, 'className');

                    for (var i = 0; i < uniqueClassNameItems.length; i++) {
                        if (uniqueClassNameItems[i].className && uniqueClassNameItems[i].className !== "")
                            this.uniqueClassNames.push(uniqueClassNameItems[i].className);
                    }

                    this.uniqueClassNames.sort();
                    this.uniqueClassNames.splice(0, 0, "");

                    this.uniqueTeamTitles = [];

                    var uniqueTeamTitleItems = $filter('unique')(this.members, 'teamName');

                    for (var i = 0; i < uniqueTeamTitleItems.length; i++) {
                        if (uniqueTeamTitleItems[i].teamName && uniqueTeamTitleItems[i].teamName !== "")
                            this.uniqueTeamTitles.push(uniqueTeamTitleItems[i].teamName);
                    }

                    this.uniqueTeamTitles.sort();
                    this.uniqueTeamTitles.splice(0, 0, "");

                    this.uniqueSchoolYearNames = [];

                    var uniqueSchoolYearNameItems = $filter('unique')(this.members, 'schoolYearName');

                    for (var i = 0; i < uniqueSchoolYearNameItems.length; i++) {
                        if (uniqueSchoolYearNameItems[i].schoolYearName && uniqueSchoolYearNameItems[i].schoolYearName !== "")
                            this.uniqueSchoolYearNames.push(uniqueSchoolYearNameItems[i].schoolYearName);
                    }

                    this.uniqueSchoolYearNames.sort();
                    this.uniqueSchoolYearNames.splice(0, 0, "");
                }.bind(this);

                this.refresh = function () {
                    this.getData(true);
                }.bind(this);

                this.getData = function (buildSearchFilters) {
                    this.loadingNext = true;
                    receptionService.getNextEventData(this.groupId, this.groupsFrom, this.isWeekView, this.isRegGroup)
                        .then(function (data) {
                            this.members = data;

                            if (buildSearchFilters)
                                this.buildSearchFilters();

                            this.loadingNextDone = true;
                            this.loadingNext = false;

                            blobStoragePhotosService.addStudentPhotoUrlsToArray(this.members).then(function (array) {
                                this.members = array;
                            }.bind(this));

                        }.bind(this),
                            function (error) {
                                this.loadingNext = false;
                                return error;
                            }.bind(this));
                }.bind(this);

                this.getGroupDetails = function () {
                    receptionService.getGroupDetails(this.groupId)
                        .then(function (data) {
                            this.title = data.title;
                        },
                            function (error) {
                                return error;
                            });
                }.bind(this);

                this.printIt = function () {
                    var tableSelector = this.isWeekView ? 'table.week-view' : 'table.day-view';
    var tables = $(tableSelector);
    
    // fallback: find any visible table if specific selector doesn't work
    if (tables.length === 0) {
        tables = $('table:visible');
    }
    
    if (tables.length === 0) {
        console.error('No table found to print');
        return;
    }
    
    var table = tables[0].cloneNode(true);
    
    // remove the first column (the avatar)
    Array.prototype.forEach.call(table.rows, function(row) {
        if (row.firstElementChild) {
            row.removeChild(row.firstElementChild);
        }
    });
    
    // set attributes for printing
    table.setAttribute("border", "1");
    table.setAttribute("style", "border-collapse:collapse; width:100%;");
    
    // grab the stylesheets
    var stylesheets = $('link[rel=stylesheet]');

    $timeout(function () {
        var myWindow = $window.open('', '', 'width=800, height=600');
        // add the stylesheets
        for (var i = 0; i < stylesheets.length; i++) {
            myWindow.document.head.appendChild(stylesheets[i].cloneNode(true));
        }
        // add the table
        myWindow.document.body.appendChild(table);
        // invoke the print dialog
        $timeout(function () { myWindow.print(); }, 1500);
    }, 300);
                }.bind(this);

                this.exportIt = function () {
                    $window.location = `${window.EveryBuddy.WebAPI}/${receptionService.getRegGroupCsvUrl(this.groupId, this.groupsFrom.format('YYYY-MM-DD')+'T00:00:00', this.isWeekView, this.isRegGroup)}`;
                }.bind(this);

                this.search = function (item) {

                    var lookForTeam = this.searchFilters.team;
                    var lookForSchoolYear = this.searchFilters.schoolYear;
                    var lookForClassName = this.searchFilters.className;


                    var matchTeam = lookForTeam === "";
                    var matchSchoolYear = lookForSchoolYear === "";
                    var matchClassName = lookForClassName === "";

                    if (matchTeam && matchSchoolYear && matchClassName) {
                        return true;
                    }

                    matchTeam = matchTeam ||
                        (lookForTeam !== "" && item.teamName &&
                            item.teamName.toLowerCase().indexOf(lookForTeam.toLowerCase()) >= 0);

                    matchSchoolYear = matchSchoolYear || (lookForSchoolYear !== "" && item.schoolYearName &&
                        item.schoolYearName.toLowerCase().indexOf(lookForSchoolYear.toLowerCase()) >= 0);

                    matchClassName = matchClassName || (lookForClassName !== "" && item.className &&
                        item.className.toLowerCase().indexOf(lookForClassName.toLowerCase()) >= 0);

                    return matchTeam && matchSchoolYear && matchClassName;
                }.bind(this);

                this.sortType = 'name';
                this.sortReverse = false;
            }
        ]
    });

